import { CFVideo } from '@/data/portfolio/type/client-index'
import classNames from 'classnames'
import { descriptionMultiCols } from '../sharedTypes'

export type FullHeightVideosProps = {
  videosCfIds: CFVideo[]
  alignement?: string
  title?: string
  description?: descriptionMultiCols
  variant?: number
  pl?: boolean
  pr?: boolean
}

export default function FullHeightVideos({
  videosCfIds,
  alignement = '',
  title = '',
  description = { cols: 0, content: [] },
  variant = 0,
  pl = false,
  pr = false
}: FullHeightVideosProps) {
  return (
    <>
      <div
        className={classNames(
          'relative mx-auto space-y-12 px-6  sm:px-8 md:mx-0 md:flex md:h-full md:max-h-[62rem] md:space-y-0 md:px-0 md:py-24',
          alignement,
          {
            'md:pl-40': pl,
            'md:pr-40': pr
          }
        )}>
        {title && (
          <div className="flex h-full flex-col justify-center md:mr-16">
            <div>
              <h2 className="font-serif text-5xl font-bold">{title}</h2>
              <div className="mt-4 md:max-w-[18rem]">
                {description.content.map((thisDesc) => (
                  <p key={thisDesc} className="hyphenate mb-4">
                    {thisDesc}
                  </p>
                ))}
              </div>
            </div>
          </div>
        )}
        {variant === 1 && (
          <div
            aria-hidden="true"
            className="absolute left-[-8.5rem] bottom-10 -z-10 hidden h-36 w-72 rounded-t-full bg-orange-200 md:block"
          />
        )}
        {variant === 2 && (
          <div
            className="absolute -bottom-20 -right-8 -z-10 hidden h-96 w-48 rounded-l-full border-4 border-blue-200 bg-transparent md:block"
            aria-hidden="true"
          />
        )}
        {variant === 3 && (
          <div
            className="absolute bottom-24 -left-20 -z-10 hidden h-48 w-96 rounded-t-full border-4 border-blue-200 bg-transparent md:block"
            aria-hidden="true"
          />
        )}
        {variant === 4 && (
          <div
            className="absolute bottom-24 -right-20 -z-10 hidden h-48 w-96 rounded-t-full border-4 border-blue-200 bg-transparent md:block"
            aria-hidden="true"
          />
        )}
        {/* className="featuredImage-grid grid gap-4 grid-rows-2" */}
        <div className="flex h-full flex-col justify-center">
          <div className="featuredVideos-grid grid gap-6">
            {videosCfIds.map((thisVideo, index) => (
              <div key={thisVideo.id} className="videoContainer relative">
                <iframe
                  src={`https://customer-22mw93wf0jovsclf.cloudflarestream.com/${thisVideo.id}/iframe?loop=true${
                    thisVideo.cover ? '&poster=' + thisVideo.cover : ''
                  }`}
                  style={{ border: 'none', position: 'absolute', top: 0, left: 0, height: '100%', width: '100%' }}
                  allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                  allowFullScreen={true}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .featuredVideos-grid {
            grid-template-columns: repeat(1, minmax(0, 1fr));
            grid-template-rows: repeat(${Math.ceil(videosCfIds.length)}, minmax(0, 1fr));
          }
          .videoContainer {
            width: 100%;
            padding-bottom: ${(16 / 9) * 100}%;
          }

          @media (min-width: 768px) {
            .featuredVideos-grid {
              grid-template-columns: repeat(${Math.ceil(videosCfIds.length)}, minmax(0, 1fr));
              grid-template-rows: repeat(1, minmax(0, 1fr));
            }
            .videoContainer {
              min-height: 36rem;
              min-width: calc(36rem / ${16 / 9});
              height: calc(100vh - 12rem);
              width: calc((100vh - 12rem) / ${16 / 9});
              max-height: 36rem;
              max-width: calc(50rem / ${16 / 9});
            }
          }
        `}
      </style>
    </>
  )
}
